import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _listPublishedSiteUrlsRequest = {};
var _listPublishedSiteUrlsResponse = {};
var _listSiteUrlsRequest = {};
var _listSiteUrlsResponse = {};
function resolveComWixpressUrlsApiV2UrlsApiUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/urls-server',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/urls-server',
                destPath: '/api',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/urls-server',
                destPath: '/api',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/urls-server/v2/published-site-urls',
                destPath: '/v2/published-site-urls',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Retrieves a list of a site's published URLs.
 * @deprecated method is deprecated due to..., it has been replaced with UrlsApi.ListPublishedSiteUrls(), and will be removed on 2024-04-01.
 */
export function listSiteUrls(payload) {
    var _a = serializer(_listSiteUrlsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listSiteUrlsResponse, {}).fromJSON;
    function __listSiteUrls(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.urls.api.v2.published_site_urls',
            method: 'GET',
            methodFqn: 'com.wixpress.urls.api.v2.UrlsApi.ListSiteUrls',
            url: resolveComWixpressUrlsApiV2UrlsApiUrl({
                protoPath: '/v2/site-urls',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listSiteUrls.fromReq = fromReq;
    __listSiteUrls.__isAmbassador = true;
    return __listSiteUrls;
}
/**
 * Retrieves a list of a site's published URLs.
 * If a site hasn't been published, the call returns an empty array.
 */
export function listPublishedSiteUrls(payload) {
    var _a = serializer(_listPublishedSiteUrlsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listPublishedSiteUrlsResponse, {}).fromJSON;
    function __listPublishedSiteUrls(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.urls.api.v2.published_site_urls',
            method: 'GET',
            methodFqn: 'com.wixpress.urls.api.v2.UrlsApi.ListPublishedSiteUrls',
            url: resolveComWixpressUrlsApiV2UrlsApiUrl({
                protoPath: '/v2/published-site-urls',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listPublishedSiteUrls.fromReq = fromReq;
    __listPublishedSiteUrls.__isAmbassador = true;
    return __listPublishedSiteUrls;
}
//# sourceMappingURL=http.impl.js.map